export interface ComicCategory {
  id: string;
  name: string;
  slug: string;
  icon: string;
  count: string;
  description: string;
}

export const categories: ComicCategory[] = [
  { id: "1", name: "热血玄幻", slug: "rexue-xuanhuan", icon: "ri-fire-fill", count: "2.8万+", description: "灵气复苏、异界征途，越战越燃的力量之旅。" },
  { id: "2", name: "都市职场", slug: "dushi-zhichang", icon: "ri-building-2-fill", count: "2.2万+", description: "商海沉浮、职场逆袭，白手起家的都市传奇。" },
  { id: "3", name: "恋爱校园", slug: "lianai-xiaoyuan", icon: "ri-heart-3-fill", count: "1.9万+", description: "青春悸动、怦然心动，校园里的甜甜日常。" },
  { id: "4", name: "悬疑推理", slug: "xuanyi-tuili", icon: "ri-search-eye-line", count: "1.5万+", description: "烧脑谜题、案中案，抽丝剥茧的推理盛宴。" },
  { id: "5", name: "科幻冒险", slug: "kehuan-maoxian", icon: "ri-rocket-2-fill", count: "1.3万+", description: "星辰大海、未来世界，踏上未知的星际征途。" },
  { id: "6", name: "搞笑日常", slug: "gaoxiao-richang", icon: "ri-emotion-happy-fill", count: "1.7万+", description: "沙雕欢乐、笑点密集，治愈你的不开心的日常。" },
  { id: "7", name: "武侠仙侠", slug: "wuxia-xianxia", icon: "ri-sword-fill", count: "1.1万+", description: "仗剑天涯、御剑飞仙，快意恩仇的江湖故事。" },
  { id: "8", name: "治愈温馨", slug: "zhiyu-wenxin", icon: "ri-sun-foggy-fill", count: "9800+", description: "温柔小确幸、暖暖日常，给心灵充电的治愈系。" },
];

export default categories;